import { render, staticRenderFns } from "./BatteryMeasurementsFragment.vue?vue&type=template&id=3531bcc2&"
import script from "./BatteryMeasurementsFragment.vue?vue&type=script&lang=js&"
export * from "./BatteryMeasurementsFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports